import Carousel from './carousel';

class ModalImageVideoSlider extends Carousel {
  constructor(selector: HTMLElement | string) {
    const SPEED = 800;

    const el: HTMLElement | null = selector instanceof HTMLElement ? selector : document.querySelector(selector);

    super(selector, {
      effect: 'slide',
      grabCursor: true,
      speed: SPEED,
      slidesPerView: 1,
      loop: true,
      autoplay: false,
      navigation: {
        nextEl: selector instanceof HTMLElement ? selector.closest('.o-modal-images-videos')?.querySelector('.swiper-button-next') : '.swiper-button-next',
        prevEl: selector instanceof HTMLElement ? selector.closest('.o-modal-images-videos')?.querySelector('.swiper-button-prev') : '.swiper-button-prev',
      },
      on: {
        update: (swiper: any) => {
          if (swiper.el.querySelectorAll('.swiper-slide').length <= 1) {
            swiper.unsetGrabCursor();
            swiper.params.grabCursor = false;
            el?.classList.add('swiper-no-swiping');
          }else {
            swiper.autoplay.stop();
            swiper.unsetGrabCursor();
            swiper.params.grabCursor = true;
            el?.classList.remove('swiper-no-swiping');
          }
        },
      },
    });
  }

  init() {
    super.init();
  }
}

export default ModalImageVideoSlider;
